/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Permissions_RequiredInputs */

const vi_api_keys_permissions_required = /** @type {(inputs: Api_Keys_Permissions_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ít nhất một quyền cho khoá đối tác.`)
};

/**

* @param {Api_Keys_Permissions_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_permissions_required = /** @type {((inputs?: Api_Keys_Permissions_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Permissions_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_permissions_required(inputs)
});